import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=18f5a1c0&"
import script from "./FormTemplate.vue?vue&type=script&lang=ts&"
export * from "./FormTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports